import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "assets/theme";
import routes from "routes";
import Presentation from "./pages";
import SignInPage from "pages/SignIn";
import NotFound from "pages/NotFound";
import ProtectedRoute from "sections/ProtectedRoute";
import AdminLayout from "pages/Admin/AdminLayout";
import Dashboard from "pages/Admin/pages/Dashboard";
import Enquiries from "pages/Admin/pages/Enquiries";
import AdminNotFound from "pages/Admin/pages/AdminNotFound";
import TutorList from "pages/Admin/components/TutorList";
import JobList from "pages/Admin/components/JobList";
import Teachers from "pages/Admin/components/Teachers";
import Results from "pages/Admin/components/Results";
import Campaigns from "pages/Admin/components/Campaigns";
import YouTube from "pages/Admin/components/Youtube";
import "./App.css";

export default function App() {
  const { pathname } = useLocation();

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.name} />;
      }

      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        {getRoutes(routes)}
        <Route path="/" element={<Presentation />} />
        <Route path="/login" element={<SignInPage />} />

        {/* Admin sections are nested routes rather than useState, so each one
            has its own URL: refreshing, bookmarking and the back button all
            work, and ProtectedRoute still guards the whole subtree. */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="tutors" element={<TutorList />} />
          <Route path="jobs" element={<JobList />} />
          <Route path="enquiries" element={<Enquiries />} />
          <Route path="teachers" element={<Teachers />} />
          <Route path="results" element={<Results />} />
          <Route path="campaigns" element={<Campaigns />} />
          <Route path="youtube" element={<YouTube />} />
          <Route path="*" element={<AdminNotFound />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </ThemeProvider>
  );
}
